module.exports = __webpack_public_path__ + "static/biennale-thin-it-105dd70f82d2840b8a80e988e5c99c2f.otf";